<template>
  <div class="cashcoupon communitymsg">
    <header>
      <ul>
        <li
          :class="{ navColor: navIndex == index }"
          v-for="(item, index) of nav"
          @click="navClick(index)"
        >
          <van-badge :content="item.num" max="99">
            {{ item.name }}
          </van-badge>
        </li>
      </ul>
    </header>
    <Scroller
      :is-refresh-data.sync="refresh"
      :is-loading-data.sync="loading"
      :is-finished-data.sync="finished"
      :no-data-text-data.sync="noDataText"
      @on-infinite="onInfinite"
      @on-refresh="onRefresh"
      class="my_scroller"
      ref="my_scroller"
    >
      <div class="list" v-if="list && list.length > 0">
        <ul v-if="navIndex != 2">
          <li v-for="(item, index) of list" :key="index">
            <div class="evaluation" @click="godetail(item)">
              <img
                v-if="item.authorhead"
                :src="item.authorhead"
                @error="
                  (event) => {
                    let img = event.srcElement
                    img.src = errorHeadImg
                    img.onerror = null
                  }
                "
              />
              <img v-if="!item.authorhead" :src="errorHeadImg" />
              <div class="content">
                <div class="f14">
                  <span
                    class="authorname f14"
                    :class="{
                      long: navIndex == 1 && item.msgtype == 3,
                      long1: navIndex == 1 && item.msgtype != 3
                    }"
                  >
                    {{ item.authorname }}
                    <b :class="{ gray: item.msgtype != 0 && item.msgtype != 1 }">
                      {{
                        item.msgtype == 0
                          ? '评论了你'
                          : item.msgtype == 1
                          ? '回复了你'
                          : item.msgtype == 2
                          ? '赞了你的帖子'
                          : item.msgtype == 3
                          ? '收藏了你的帖子'
                          : item.msgtype == 4
                          ? '赞了你的评论'
                          : ''
                      }}
                    </b>
                  </span>
                  <span class="f11 flex-ac">
                    {{ item.time }}&nbsp;
                    <van-badge v-if="item.isread != 1" dot />
                  </span>
                </div>
                <p v-if="navIndex == 0" class="f14">{{ item.msg }}</p>
                <p v-else-if="item.subject" class="f11 red">#{{ item.subject }}</p>
              </div>
            </div>
            <div class="post" :class="{ gray: navIndex == 0 }" @click="godetail(item)">
              <p class="f14 over-ell-3">{{ item.isdelete == 0 ? item.content : '该帖子已删除' }}</p>
              <img v-lazy="item.coverimg" />
            </div>
            <button class="f11" v-if="navIndex == 0" @click.stop="commentFn(item)">回复</button>
          </li>
        </ul>
        <ul v-else>
          <li v-for="(item, index) of list" :key="index" @click="readFn(item)">
            <div class="evaluation">
              <img src="/static/images/community/sm@2x.png" />
              <div class="content">
                <div class="f14">
                  <span class="authorname f14">官方助手</span>
                  <span class="f11 flex-ac">
                    {{ item.time }}&nbsp;
                    <van-badge v-if="item.isread != 1" dot />
                  </span>
                </div>
              </div>
            </div>
            <div class="post">
              <p class="f14">{{ item.content }}</p>
            </div>
          </li>
        </ul>
      </div>
    </Scroller>
    <div class="leaveMsg" v-if="show">
      <div class="inp">
        <img src="../../assets/images/edit.png" />
        <!--<input placeholder="说点什么…"/>-->
        <textarea
          class="van-cell"
          id="comment"
          @focus="enter"
          @blur="leave"
          :placeholder="placeholder"
          v-model="value"
        ></textarea>
        <!--<van-field @focus="submit = true" @blur="submit = false" v-model="value" placeholder="说点什么…" />-->
      </div>
      <div class="btn">
        <!--<div class="msg" v-if="value.length <= 0">-->
        <!--<img src="../../assets/images/ly.png"/>{{commentinfo.commentinfo.comment_nums}}&nbsp;-->
        <!--</div>-->
        <!--v-if="value.length > 0"-->
        <div class="msg" @click="submitComment">
          发送
        </div>
      </div>
    </div>
    <div
      v-if="empty"
      class="emptybox"
      :style="{ height: emptyHeight / 100 + 'rem', padding: '0.1rem 0.11rem 0.1rem' }"
    >
      <empty v-if="empty" :path="'noMsg'" :noDatades="noDatades"></empty>
    </div>
  </div>
</template>

<script>
import empty from '../emptypage/empty'
import Scroller from '../common/Scroller'
import { isWeixin, fenxiang } from '../../assets/common/js/config'

export default {
  name: 'communityMsg',
  components: {
    empty,
    Scroller
  },
  data() {
    return {
      nav: [
        { name: '评论/回复', num: '' },
        { name: '点赞/收藏', num: '' },
        { name: '官方消息', num: '' }
      ],
      navIndex: 0,
      list: [],
      listIndex: null,
      refresh: false,
      loading: false,
      finished: false,
      empty: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——',
      emptyHeight: 0,
      noDatades: 1,
      placeholder: '说点什么…',
      value: '',
      show: false,
      commentObj: null
    }
  },
  mounted: function() {
    this.emptyHeight =
      document.body.clientHeight - document.getElementsByTagName('header')[0].clientHeight + 10
    this.noDatades = this.navIndex == 0 ? 1 : this.navIndex == 1 ? 2 : 3
  },
  destroyed: function() {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/') {
      // 当前页面刷新不需要切换位置
      next((vm) => {
        if (isWeixin()) fenxiang({ path: 'communitymsg' })
        vm.nowPage = 0
        vm.emptyHeight =
          document.body.clientHeight - document.getElementsByTagName('header')[0].clientHeight + 10
      })
    } else {
      next((vm) => {
        if (isWeixin()) fenxiang({ path: 'communitymsg' })
        if (from.path == '/community') {
          Object.assign(vm.$data, vm.$options.data())
          vm.clear()
          vm.emptyHeight =
            document.body.clientHeight -
            document.getElementsByTagName('header')[0].clientHeight +
            10
        }
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    if (to.path == '/community') this.loading = true
    next()
  },
  methods: {
    getData: function() {
      var url =
        this.$ajax.getNews_URL +
        '?type=' +
        this.navIndex +
        '&pageno=' +
        this.nowPage +
        '&pagesize=' +
        this.pagesize
      if (this.navIndex == 2)
        url =
          this.$ajax.getOfficialMsg_URL + '?pageno=' + this.nowPage + '&pagesize=' + this.pagesize
      var that = this
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.nav[0].num = parseInt(res.data.commentnum) ? res.data.commentnum : ''
          that.nav[1].num = parseInt(res.data.likenum) ? res.data.likenum : ''
          that.nav[2].num = parseInt(res.data.officialnum) ? res.data.officialnum : ''
          if (that.nowPage === 1) {
            that.list = res.data.list
            that.refresh = false
          } else {
            that.list = that.list.concat(res.data.list)
          }
          that.loading = false
          if (that.list.length <= 0) {
            that.empty = true
          } else {
            that.empty = false
          }
          if (res.data.list.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    godetail: function(item) {
      item.isread = 1
      if (item.isdelete != 1) {
        if (item.isbeautitysaid == 1) {
          this.$router.push({
            path: '/beautitysaiddetail',
            query: {
              beautitysaidid: item.itemid
            }
          })
        } else {
          this.$router.push({
            path: '/communitydetail',
            query: {
              id: item.itemid
            }
          })
        }
      } else {
        this.$toast('该帖子已被删除')
      }
    },
    readFn(item) {
      item.isread = 1
    },
    clear(fn) {
      let url = this.$ajax.cleanNews_URL,
        data = {
          type: this.navIndex + 1
        }
      this.$customRequestAjax.post(url, data).then((res) => {
        this.nav[this.navIndex].num = ''
        if (typeof fn == 'function') fn(res)
      })
    },
    commentFn: function(item) {
      item.isread = 1
      if (item.isdelete != 1) {
        this.commentObj = item
        this.show = true
        this.$nextTick(function() {
          document.getElementById('comment').focus()
        })
      } else {
        this.$toast('该帖子已被删除')
      }
    },
    leave: function() {
      setTimeout(() => {
        this.show = false
        if (this.value == '') {
          this.commentObj = null
          this.placeholder = '说点什么…'
        }
      }, 50)
    },
    enter: function() {
      this.show = true
    },
    onRefresh() {
      this.refresh = true
      this.nowPage = 1
      var that = this
      that.getData()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      var that = this
      that.nowPage++
      that.getData()
    },
    navClick: function(id) {
      if (this.navIndex != id) {
        this.navIndex = id
        this.clear()
        this.noDatades = this.navIndex == 0 ? 1 : this.navIndex == 1 ? 2 : 3
        this.list = []
        this.nowPage = 0
        this.onInfinite()
      }
    },
    submitComment: function() {
      if (!this.commentObj && !this.value) return
      var url, data
      if (this.commentObj.msgtype == 0) {
        url = this.$ajax.commentReply_URL
        data = {
          commentid: this.commentObj.msgid,
          replycontent: this.value
        }
        if (this.commentObj.isbeautitysaid == 1) {
          url = this.$ajax.addCommentReply_URL
        }
      }
      if (this.commentObj.msgtype == 1) {
        url = this.$ajax.reply_URL
        data = {
          replyid: this.commentObj.msgid,
          replycontent: this.value
        }
        if (this.commentObj.isbeautitysaid == 1) {
          url = this.$ajax.addReply_URL
        }
      }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          this.$toast('回复成功')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.cashcoupon {
  header {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 0.46rem;
    background: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    ul {
      font-size: 0;
      li {
        display: inline-block;
        font-size: 0.17rem;
        color: #222222;
        margin-right: 0.28rem;
        &:last-of-type {
          margin-right: 0;
        }
        &.navColor {
          /*color: #FE0F41;*/
          font-weight: 600;
          position: relative;
          &:after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            display: block;
            width: 0.26rem;
            height: 0.03rem;
            background: linear-gradient(90deg, #fc0324 0%, #fc0324 100%);
          }
        }
      }
    }
  }
  .list {
    ul {
      margin-top: 0.56rem;
      li {
        overflow: hidden;
        background: #ffffff;
        margin: 0 0.11rem 0.1rem;
        padding: 0.1rem 0.11rem;
        border-radius: 0.04rem;
        .evaluation {
          display: flex;
          img {
            width: 0.37rem;
            height: 0.37rem;
            border-radius: 50%;
            margin-right: 0.1rem;
            flex-shrink: 0;
          }
          .content {
            flex: 1;
            div {
              display: flex;
              justify-content: space-between;
              align-items: center;
              span {
                color: #999999;
                white-space: nowrap;
                &.authorname {
                  overflow: hidden;
                  white-space: normal;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
                  padding-right: 0.55rem;
                  position: relative;
                  &.long {
                    padding-right: 0.9rem;
                  }
                  &.long1 {
                    padding-right: 0.8rem;
                  }
                }
                &.authorname b {
                  font-weight: 400;
                  color: #338bf6;
                  font-size: 0.11rem;
                  margin-left: 0.04rem;
                  position: absolute;
                  right: 0.03rem;
                  bottom: 1px;
                  &.gray {
                    color: #afb0af;
                  }
                }
              }
            }
            p {
              color: #222222;
              margin-top: 0.06rem;
              margin-bottom: 0.08rem;
              &.red {
                color: #fc0324;
                margin-top: 0.01rem;
              }
            }
          }
        }
        .post {
          display: flex;
          justify-content: space-between;
          padding: 0.06rem;
          border-radius: 0.04rem;
          &.gray {
            background: #f5f5f5;
          }
          p {
            color: #222222;
            overflow: hidden;
            line-height: 0.2rem;
          }
          img {
            width: 0.62rem;
            height: 0.62rem;
            border-radius: 0.04rem;
            flex-shrink: 0;
            margin-left: 0.08rem;
          }
        }
        button {
          width: 0.64rem;
          height: 0.24rem;
          text-align: center;
          line-height: 0.24rem;
          border: 0.01rem solid #fc0324;
          border-radius: 0.12rem;
          color: #fc0324;
          display: block;
          float: right;
          background: transparent;
          margin-top: 0.08rem;
        }
      }
    }
  }
  .leaveMsg {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0.43rem;
    border-top: solid 1px rgba(0, 0, 0, 0.25);
    z-index: 9;
    background: #fff;
    padding: 0 0.11rem;
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -o-flex;
    display: -ms-flex;
    align-items: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    -o-align-items: center;
    -ms-align-items: center;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -moz-justify-content: space-between;
    -o-justify-content: space-between;
    -ms-justify-content: space-between;
    .inp {
      /*width: 2.11rem;*/
      background: #f5f5f5;
      height: 0.29rem;
      display: flex;
      align-items: center;
      font-size: 0.13rem;
      border-radius: 0.15rem;
      color: #999999;
      flex: 1;
      -webkit-flex: 1;
      -moz-flex: 1;
      -ms-flex: 1;
      -o-flex: 1;
      input {
        border: 0;
        background: #f5f5f5;
        color: #292929;
      }
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-left: 0.1rem;
        margin-right: 0.05rem;
        pointer-events: none;
        -webkit-user-select: none;
        -webkit-touch-callout: none;
        word-break: break-word;
      }
    }
    .btn {
      display: flex;
      display: -webkit-flex;
      display: -ms-flex;
      display: -moz-flex;
      display: -o-flex;
      align-items: center;
      -webkit-align-items: center;
      -ms-align-items: center;
      -moz-align-items: center;
      -o-align-items: center;
    }
    .msg {
      float: left;
      margin-left: 0.1rem;
      font-size: 0.13rem;
      padding: 0.05rem;
      color: #ffffff;
      width: 0.5rem;
      height: 0.29rem;
      text-align: center;
      border-radius: 0.19rem;
      background: linear-gradient(90deg, #fc0324 0%, #ff144f 100%);
    }
  }
}
</style>
<style lang="scss">
.communitymsg {
  .van-badge {
    font-weight: normal;
    font-size: 0.1rem;
  }
  .van-badge--dot {
    width: 0.06rem;
    height: 0.06rem;
    border-radius: 50%;
    padding: 0;
  }
  .leaveMsg {
    .van-cell {
      line-height: 0.29rem;
      background-color: transparent;
      width: 82%;
      padding: 0;
      height: 0.29rem;
      border: 0;
      outline: none;
      overflow-y: auto;
      &::placeholder {
        line-height: 0.29rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community/communityMsg.vue